import { useIntl } from 'react-intl';
import { Hook } from '@rossum/api-client/hooks';
import { DeleteConfirmationDialog } from '@rossum/components/delete-confirmation-dialog/DeleteConfirmationDialog';
import { boldText } from '../../../lib/formaterValues';
import { useDeleteHook } from '../hooks/useDeleteHook';

export const DeleteExtensionDialog = ({
  extension,
  open,
  onClose,
  onDelete,
}: {
  extension: Hook | undefined;
  open: boolean;
  onClose: () => void;
  onDelete?: () => void;
}) => {
  const intl = useIntl();

  const { mutate } = useDeleteHook();

  return (
    <DeleteConfirmationDialog
      title={intl.formatMessage({
        id: 'features.queueSettings.rules.deleteExtensionConfirmation.title',
      })}
      description={intl.formatMessage(
        {
          id: 'features.queueSettings.rules.deleteExtensionConfirmation.text',
        },
        {
          name: extension?.name ?? '',
          queues: extension?.queues.length ?? 0,
          bold: boldText,
        }
      )}
      open={open}
      onCancel={() => onClose()}
      onConfirm={() => {
        if (extension) {
          mutate(
            { hookId: extension.id },
            {
              onSuccess: () => {
                onDelete?.();
                onClose();
              },
            }
          );
        }
      }}
    />
  );
};
